import { OverlayTrigger, Tooltip } from "react-bootstrap";

const SchemeCell = ({
  countryCode,
  countryName,
}: {
  countryCode: string;
  countryName: string;
}) => {
  if (!countryCode) return null;

  return (
    <OverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="button-tooltip-2">{countryName}</Tooltip>}
    >
      {({ ref, ...triggerHandler }) => (
        <img
          ref={ref}
          {...triggerHandler}
          src={require(`/src/images/flags2/${countryCode.toLowerCase()}.png`)}
          height="50px"
          width="50px"
          alt={`${countryName} Flag`}
        />
      )}
    </OverlayTrigger>
  );
};

export default SchemeCell;
